import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { GET_VENDOR_TASK_LIST,UPDATE_VENDOR_TASK_DETAIL,updateVendorTaskUrl, getVendorTaskUrl, headers } from '../../utils/constants'



export const getVendorTaskList_action = (VendorID,StatusID) => async (dispatch) => {

    try {
        const mapdata = {
            VendorID: VendorID !='' ? VendorID: null,
            StatusID: StatusID || null,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorTaskUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_TASK_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updateVendorTask_action = (ExhVendorPlanHdrID, taskDetails,subTaskDetails,dailyRoutineTaskDetails,attachmentDetails) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhVendorPlanHdrID: ExhVendorPlanHdrID != '' ? parseInt(ExhVendorPlanHdrID) : null,
            taskDetails: taskDetails,
            subTaskDetails: subTaskDetails,
            dailyRoutineTaskDetails:dailyRoutineTaskDetails,
            attachmentDetails:attachmentDetails
        }

        const res = await axiosPost(updateVendorTaskUrl, params, headers)

        dispatch({
            type: UPDATE_VENDOR_TASK_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}